document.addEventListener('DOMContentLoaded', function () {
  initRevelado();
  initComparador();
  initGaleriaProducto();
  initVariantesProducto();
});

function initRevelado() {
  var els = document.querySelectorAll('.pr-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('pr-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('pr-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el, i) {
    el.style.setProperty('--pr-delay', (i % 6) * 0.09 + 's');
    observer.observe(el);
  });
}

function initComparador() {
  document.querySelectorAll('.pr-comparador__slider').forEach(function (slider) {
    var input = slider.querySelector('.pr-comparador__input');
    var pista = slider.querySelector('.pr-comparador__pista');
    if (!input) return;

    function fijarPorcentaje(pct) {
      pct = Math.max(0, Math.min(100, pct));
      slider.style.setProperty('--pr-pos', pct + '%');
      input.value = pct;
    }

    function porcentajeDesdeX(clientX) {
      var rect = slider.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }

    function ocultarPista() {
      if (pista) pista.classList.add('pr-comparador__pista--oculta');
    }

    var arrastrando = false;

    slider.addEventListener('pointerdown', function (e) {
      arrastrando = true;
      if (slider.setPointerCapture) slider.setPointerCapture(e.pointerId);
      fijarPorcentaje(porcentajeDesdeX(e.clientX));
      ocultarPista();
    });
    slider.addEventListener('pointermove', function (e) {
      if (!arrastrando) return;
      fijarPorcentaje(porcentajeDesdeX(e.clientX));
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (evento) {
      slider.addEventListener(evento, function () {
        arrastrando = false;
      });
    });

    input.addEventListener('input', function () {
      fijarPorcentaje(parseFloat(input.value));
      ocultarPista();
    });

    fijarPorcentaje(parseFloat(input.value) || 50);
  });
}

function initGaleriaProducto() {
  document.querySelectorAll('[data-pr-galeria]').forEach(function (galeria) {
    var principal = galeria.querySelector('[data-pr-imagen-principal]');
    var miniaturas = galeria.querySelectorAll('[data-pr-miniatura]');
    if (!principal || !miniaturas.length) return;
    miniaturas.forEach(function (min) {
      min.addEventListener('click', function () {
        var src = min.getAttribute('data-full');
        if (src) principal.src = src;
        miniaturas.forEach(function (m) { m.classList.remove('pr-activa'); });
        min.classList.add('pr-activa');
      });
    });
  });
}

function initVariantesProducto() {
  document.querySelectorAll('[data-pr-producto]').forEach(function (wrapper) {
    var variantesEl = wrapper.querySelector('[data-pr-variantes-json]');
    if (!variantesEl) return;
    var variantes;
    try {
      variantes = JSON.parse(variantesEl.textContent);
    } catch (e) {
      return;
    }
    var form = wrapper.querySelector('form');
    var idInput = form.querySelector('input[name="id"]');
    var precioEl = wrapper.querySelector('[data-pr-precio]');
    var precioTachadoEl = wrapper.querySelector('[data-pr-precio-tachado]');
    var boton = wrapper.querySelector('[data-pr-boton-comprar]');
    var textoDisponible = boton ? boton.getAttribute('data-texto-disponible') : '';
    var textoAgotado = boton ? boton.getAttribute('data-texto-agotado') : '';
    var seleccion = {};

    form.querySelectorAll('[data-pr-opcion]').forEach(function (grupo) {
      var nombreOpcion = grupo.getAttribute('data-pr-opcion');
      var valorActivo = grupo.querySelector('.pr-activa');
      if (valorActivo) seleccion[nombreOpcion] = valorActivo.getAttribute('data-valor');

      grupo.querySelectorAll('[data-pr-valor]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          grupo.querySelectorAll('[data-pr-valor]').forEach(function (b) { b.classList.remove('pr-activa'); });
          btn.classList.add('pr-activa');
          seleccion[nombreOpcion] = btn.getAttribute('data-valor');
          actualizarVariante();
        });
      });
    });

    function actualizarVariante() {
      var match = variantes.find(function (v) {
        return v.optionNames.every(function (name, i) { return seleccion[name] === v.options[i]; });
      });
      if (!match) return;
      idInput.value = match.id;
      if (precioEl) precioEl.textContent = match.priceFormatted;
      if (precioTachadoEl) {
        if (match.hasCompareAtPrice) {
          precioTachadoEl.textContent = match.compareAtPriceFormatted;
          precioTachadoEl.style.display = '';
        } else {
          precioTachadoEl.style.display = 'none';
        }
      }
      if (boton) {
        if (match.available) {
          boton.disabled = false;
          boton.textContent = textoDisponible || boton.textContent;
        } else {
          boton.disabled = true;
          boton.textContent = textoAgotado || boton.textContent;
        }
      }
    }

    actualizarVariante();
  });
}
